/*
 * @Description: 总路由
 * @Version: 1.0
 * @Date: 2019-12-10 20:33:34
 * @Autor: LIANGYU
 * @LastEditTime : 2020-01-21 15:24:59
 * @LastEditors  : Please set LastEditors
 */
import Vue from "vue";
import Router from "vue-router";
import personalCenter from "./modules/personalCenter";
import home from './modules/home';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
  ].concat(home,personalCenter)
});


// WEBPACK FOOTER //
// ./src/router/index.js